
function ArticleAbout() {
  return (
    <div className="landingPage">
      <div className="landingImage"></div>
      <div className="landingPageIntro">
        <h1 className="landingPageIntroText">
          Et Fredrikstadbasert fotograf-firma{" "}
          <span className="textSpan">som tar oppdrag for</span>
          privatpersoner og bedrifter.
        </h1>
      </div>
    </div>
  );
}

export default ArticleAbout;